import i18n from "../i18n";

/** @var Типы загружаемых документов*/
export const DOCS_COMBINATION = {
  basic: [{docName:'registrationOfALegalEntityWithTaxAuthority', isMultiple: true},
    {docName:'charterWithAllAmendments', isMultiple: true},
    {docName:'proofOfOwnership', isMultiple: true},
    {docName:'protocolOfTheGeneralMeetingOfParticipants', isMultiple: true},
    {docName:'partnerCard', isMultiple: true},
    {docName:'copyOfThePassport', isMultiple: true},
    {docName:'certificateOfStateRegistration', isMultiple: true}
  ],
  isNdsPayer: [{docName:'incomeTaxForTheLastReportingPeriod', isMultiple: true},
    {docName:'nDSReturnForTheLastReportingPeriod', isMultiple: true},
    {docName:'bookkeepingBalance', isMultiple: true},
    {docName:'certificateFromIFNSOnTheStatusOfSettlementsWithTheBudget', isMultiple: true},
    {docName:'staffingTable', isMultiple: true}],
  isNeedPowerOfAttorneyForAPerson: [{docName:'powerOfAttorneyForAPerson', isMultiple: true}],
  isProprietor: [{docName:'partnerCard', isMultiple: true},
    {docName:'copyOfThePassport', isMultiple: true},
    {docName:'certificateOfStateRegistration', isMultiple: true},
    {docName:'certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority', isMultiple: true}],
  organizationalForm: {
    26: [{docName:'partnerCard', isMultiple: true},
      {docName:'copyOfThePassport', isMultiple: true},
      {docName:'requisites', isMultiple: true},
      {docName:'decisionToCreate', isMultiple: true},
      {docName:'registeredMemorandumOfAssociation', isMultiple: true},
      {docName:'certificateOfStateRegistration', isMultiple: true},
      {docName:'certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority', isMultiple: true}
    ]
  }
}

export const getWithTranslate = (constantName) => {
  const allConstants = {
    legalEntityDataAliases: {
      LegalEntityID: i18n.t('constants.legalEntityDataAliases.LegalEntityID'),
      OrgForm: i18n.t('constants.legalEntityDataAliases.OrgForm'),
      DateRegistration: i18n.t('constants.legalEntityDataAliases.DateRegistration'),
      Name: i18n.t('constants.legalEntityDataAliases.Name'),
      WorkWithNds: i18n.t('constants.legalEntityDataAliases.WorkWithNds'),
      LegalReason: i18n.t('constants.legalEntityDataAliases.LegalReason'),
      FirstName: i18n.t('constants.legalEntityDataAliases.FirstName'),
      SecondName: i18n.t('constants.legalEntityDataAliases.SecondName'),
      Patronymic: i18n.t('constants.legalEntityDataAliases.Patronymic'),
      Inn: i18n.t('constants.legalEntityDataAliases.Inn'),
      Kpp: i18n.t('constants.legalEntityDataAliases.Kpp'),
      Ogrn: i18n.t('constants.legalEntityDataAliases.Ogrn'),
      Ogrnip: i18n.t('constants.legalEntityDataAliases.Ogrnip'),
      Okpo: i18n.t('constants.legalEntityDataAliases.Okpo'),
      Rs: i18n.t('constants.legalEntityDataAliases.Rs'),
      Bic: i18n.t('constants.legalEntityDataAliases.Bic'),
      BankName: i18n.t('constants.legalEntityDataAliases.BankName'),
      Country: i18n.t('constants.legalEntityDataAliases.Country'),
      RegAddress: i18n.t('constants.legalEntityDataAliases.RegAddress'),
      MailingAddress: i18n.t('constants.legalEntityDataAliases.MailingAddress'),
      LegalAddress: i18n.t('constants.legalEntityDataAliases.LegalAddress'),
      LegalAddressPostalCode: i18n.t('constants.legalEntityDataAliases.LegalAddressPostalCode'),
      AtiCode: i18n.t('constants.legalEntityDataAliases.AtiCode'),
      Position: i18n.t('constants.legalEntityDataAliases.Position'),
      PositionStr: i18n.t('constants.legalEntityDataAliases.PositionStr'),
      GuarantorFirstName: i18n.t('constants.legalEntityDataAliases.GuarantorFirstName'),
      GuarantorSecondName: i18n.t('constants.legalEntityDataAliases.GuarantorSecondName'),
      GuarantorPatronymic: i18n.t('constants.legalEntityDataAliases.GuarantorPatronymic'),
      GuarantorPassportSerial: i18n.t('constants.legalEntityDataAliases.GuarantorPassportSerial'),
      GuarantorPassportNumber: i18n.t('constants.legalEntityDataAliases.GuarantorPassportNumber'),
      GuarantorPassportDate: i18n.t('constants.legalEntityDataAliases.GuarantorPassportDate'),
      GuarantorPassportDivision: i18n.t('constants.legalEntityDataAliases.GuarantorPassportDivision'),
      GuarantorAddressRegistration: i18n.t('constants.legalEntityDataAliases.GuarantorAddressRegistration'),
      GuarantorAddressFact: i18n.t('constants.legalEntityDataAliases.GuarantorAddressFact'),
      certificateOfStateRegistration: i18n.t('constants.legalEntityDataAliases.certificateOfStateRegistration'),
      certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority: i18n.t('constants.legalEntityDataAliases.certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority'),
      dischargeFromEGRIP: i18n.t('constants.legalEntityDataAliases.dischargeFromEGRIP'),
      partnerCard: i18n.t('constants.legalEntityDataAliases.partnerCard'),
      certificateOfCalculationsWithTheBudget: i18n.t('constants.legalEntityDataAliases.certificateOfCalculationsWithTheBudget'),
      copyOfThePassport: i18n.t('constants.legalEntityDataAliases.copyOfThePassport'),
      decisionToCreateSociety: i18n.t('constants.legalEntityDataAliases.decisionToCreateSociety'),
      charterWithAllAmendments: i18n.t('constants.legalEntityDataAliases.charterWithAllAmendments'),
      protocolOfTheGeneralMeetingOfParticipants: i18n.t('constants.legalEntityDataAliases.protocolOfTheGeneralMeetingOfParticipants'),
      certificateOfEntry: i18n.t('constants.legalEntityDataAliases.certificateOfEntry'),
      dischargeFromEGRUL: i18n.t('constants.legalEntityDataAliases.dischargeFromEGRUL'),
      powerOfAttorneyForAPerson: i18n.t('constants.legalEntityDataAliases.powerOfAttorneyForAPerson'),
      bookkeepingBalance: i18n.t('constants.legalEntityDataAliases.bookkeepingBalance'),
      profitsAndLossesReport: i18n.t('constants.legalEntityDataAliases.profitsAndLossesReport'),
      incomeTaxAndNDSDeclaration: i18n.t('constants.legalEntityDataAliases.incomeTaxAndNDSDeclaration'),
      proofOfOwnership: i18n.t('constants.legalEntityDataAliases.proofOfOwnership'),
      copyOfBankCard: i18n.t('constants.legalEntityDataAliases.copyOfBankCard'),
      incomeTaxForTheLastReportingPeriod: i18n.t('constants.legalEntityDataAliases.incomeTaxForTheLastReportingPeriod'),
      nDSReturnForTheLastReportingPeriod: i18n.t('constants.legalEntityDataAliases.nDSReturnForTheLastReportingPeriod'),
      certificateFromIFNSOnTheStatusOfSettlementsWithTheBudget: i18n.t('constants.legalEntityDataAliases.certificateFromIFNSOnTheStatusOfSettlementsWithTheBudget'),
      staffingTable: i18n.t('constants.legalEntityDataAliases.staffingTable'),
      registeredMemorandumOfAssociation: i18n.t('constants.legalEntityDataAliases.registeredMemorandumOfAssociation'),
      decisionToCreate: i18n.t('constants.legalEntityDataAliases.decisionToCreate'),
      requisites: i18n.t('constants.legalEntityDataAliases.requisites'),
      registrationOfALegalEntityWithTaxAuthority: i18n.t('constants.legalEntityDataAliases.registrationOfALegalEntityWithTaxAuthority'),
      Email: i18n.t('constants.legalEntityDataAliases.Email'),
      Phone: i18n.t('constants.legalEntityDataAliases.Phone'),
      LegalNumber: i18n.t('constants.legalEntityDataAliases.LegalNumber'),
      BankUnp: i18n.t('constants.legalEntityDataAliases.BankUnp'),
      BankAddress: i18n.t('constants.legalEntityDataAliases.BankAddress'),
      AccountNumber: i18n.t('constants.legalEntityDataAliases.AccountNumber'),
      Swift: i18n.t('constants.legalEntityDataAliases.Swift'),
      Address: i18n.t('constants.legalEntityDataAliases.Address'),
      GuarantorCountry: i18n.t('constants.legalEntityDataAliases.GuarantorCountry'),
      GuarantorPassportRegistration: i18n.t('constants.legalEntityDataAliases.GuarantorPassportRegistration'),
      GuarantorPhone: i18n.t('constants.legalEntityDataAliases.GuarantorPhone'),
      GuarantorEmail: i18n.t('constants.legalEntityDataAliases.GuarantorEmail'),
      passport: i18n.t('constants.legalEntityDataAliases.passport'),
      specialPermitForTheRightToCarryOutActivities: i18n.t('constants.legalEntityDataAliases.specialPermitForTheRightToCarryOutActivities'),
      residenceCertificate: i18n.t('constants.legalEntityDataAliases.residenceCertificate'),
      articlesOfAssociation: i18n.t('constants.legalEntityDataAliases.articlesOfAssociation'),
      documentsConfirmingOwnershipOfOfficePremises: i18n.t('constants.legalEntityDataAliases.documentsConfirmingOwnershipOfOfficePremises'),
      documentsConfirmingTax: i18n.t('constants.legalEntityDataAliases.documentsConfirmingTax'),
      documentGosLog: i18n.t('constants.legalEntityDataAliases.documentGosLog'),
      documentConfirmingTheStateRegistrationOfAnIndividualEntrepreneur: i18n.t('constants.legalEntityDataAliases.documentConfirmingTheStateRegistrationOfAnIndividualEntrepreneur'),
      documentConfirmingTheStateRegistrationOfALegalEntity: i18n.t('constants.legalEntityDataAliases.documentConfirmingTheStateRegistrationOfALegalEntity'),
      certificateOfExclusionOfDoubleTaxation: i18n.t('constants.legalEntityDataAliases.certificateOfExclusionOfDoubleTaxation'),
      extractFromTheTradeRegister: i18n.t('constants.legalEntityDataAliases.extractFromTheTradeRegister'),
      permissionForTheRightToCarryOutActivitiesInTheFieldOfInternationalRoadTransport: i18n.t('constants.legalEntityDataAliases.permissionForTheRightToCarryOutActivitiesInTheFieldOfInternationalRoadTransport'),
      partnerCardKz: i18n.t('constants.legalEntityDataAliases.partnerCardKz'),
      residenceCertificateKz: i18n.t('constants.legalEntityDataAliases.residenceCertificateKz'),
      copyOfThePassportKz: i18n.t('constants.legalEntityDataAliases.copyOfThePassportKz'),
      documentsConfirmingOwnershipOfOfficePremisesBel: i18n.t('constants.legalEntityDataAliases.documentsConfirmingOwnershipOfOfficePremisesBel'),
      copyOfBankCardBel: i18n.t('constants.legalEntityDataAliases.copyOfBankCardBel'),
      certificateOfStateRegistrationBel: i18n.t('constants.legalEntityDataAliases.certificateOfStateRegistrationBel'),
      passportBel: i18n.t('constants.legalEntityDataAliases.passportBel'),
      residenceCertificateBel: i18n.t('constants.legalEntityDataAliases.residenceCertificateBel'),
      license: i18n.t('constants.legalEntityDataAliases.license'),
      gosLogStatus: i18n.t('constants.legalEntityDataAliases.gosLogStatus')
    },
    legalEntityForGosLogAliases: {
      OrgForm: i18n.t('constants.legalEntityDataAliases.OrgForm'),
      Name: i18n.t('constants.legalEntityDataAliases.Name'),
      Inn: i18n.t('constants.legalEntityDataAliases.Inn'),
      documentGosLog: i18n.t('constants.legalEntityDataAliases.documentGosLog'),
      gosLogStatus: i18n.t('constants.legalEntityDataAliases.gosLogStatus'),
    },
    FORM_FIELDS_RUS_LEGAL_ENTITY: [
      {key: "Name", title: i18n.t('constants.formFields.Name')},
      {key: "FullName", title: i18n.t('constants.formFields.FullName')},
      {key: "FirstName", title: i18n.t('constants.formFields.FirstName')},
      {key: "Patronymic", title: i18n.t('constants.formFields.Patronymic')},
      {key: "SecondName", title: i18n.t('constants.formFields.SecondName')},
      {key: "Bic", title: i18n.t('constants.formFields.Bic')},
      {key: "Rs", title: i18n.t('constants.formFields.Rs')},
      {key: "RegAddress", title: i18n.t('constants.formFields.RegAddress')},
      {key: "LegalAddress", title: i18n.t('constants.formFields.LegalAddress')},
      {key: "MailingAddress", title: i18n.t('constants.formFields.MailingAddress')}
    ],
    FORM_FIELDS_KAZ_LEGAL_ENTITY: [
      {key: "Name", title: i18n.t('constants.formFields.Name')},
      {key: "FullName", title: i18n.t('constants.formFields.FullName')},
      {key: "FirstName", title: i18n.t('constants.formFields.FirstName')},
      {key: "Patronymic", title: i18n.t('constants.formFields.Patronymic')},
      {key: "SecondName", title: i18n.t('constants.formFields.SecondName')},
      {key: "Bic", title: i18n.t('constants.formFields.Bic')},
      {key: "BankName", title: i18n.t('constants.formFields.BankName')},
      {key: "Rs", title: i18n.t('constants.formFields.Rs')},
      {key: "RegAddressRegion", title: i18n.t('constants.formFields.RegAddressRegion')},
      {key: "RegAddressLocality", title: i18n.t('constants.formFields.RegAddressLocality')},
      {key: "RegAddressStreet", title: i18n.t('constants.formFields.RegAddressStreet')},
      {key: "RegAddressHouseNumber", title: i18n.t('constants.formFields.RegAddressHouseNumber')},
      {key: "RegAddressPremiseNumber", title: i18n.t('constants.formFields.RegAddressPremiseNumber')},
      {key: "RegAddressPostalCode", title: i18n.t('constants.formFields.RegAddressPostalCode')},
      {key: "LegalAddressRegion", title: i18n.t('constants.formFields.LegalAddressRegion')},
      {key: "LegalAddressStreet", title: i18n.t('constants.formFields.LegalAddressStreet')},
      {key: "LegalAddressLocality", title: i18n.t('constants.formFields.LegalAddressLocality')},
      {key: "LegalAddressHouseNumber", title: i18n.t('constants.formFields.LegalAddressHouseNumber')},
      {key: "LegalAddressPremiseNumber", title: i18n.t('constants.formFields.LegalAddressPremiseNumber')},
      {key: "LegalAddressPostalCode", title: i18n.t('constants.formFields.LegalAddressPostalCode')}
    ],
    FORM_FIELDS_BEL_LEGAL_ENTITY: [
      {key: "Name", title: i18n.t('constants.formFields.Name')},
      {key: "FullName", title: i18n.t('constants.formFields.FullName')},
      {key: "FirstName", title: i18n.t('constants.formFields.FirstName')},
      {key: "Patronymic", title: i18n.t('constants.formFields.Patronymic')},
      {key: "SecondName", title: i18n.t('constants.formFields.SecondName')},
      {key: "Bic", title: i18n.t('constants.formFields.Bic')},
      {key: "BankName", title: i18n.t('constants.formFields.BankName')},
      {key: "AccountNumber", title: i18n.t('constants.formFields.AccountNumber')},
      {key: "AddressCity", title: i18n.t('constants.formFields.AddressCity')},
      {key: "Address", title: i18n.t('constants.formFields.Address')},
      {key: "MailingAddress", title: i18n.t('constants.formFields.MailingAddress')}
    ]
  }

  return allConstants[constantName]
}
